/**
 * @license
 * Copyright 2026 Clip Team
 * SPDX-License-Identifier: MPL-2.0
 */

import {Logger} from 'tslog';

const logger = new Logger({
    name: 'clipcc-extension'
});

export default logger;
